!function (angular) {
    "use strict";
    var module = angular.module('provider.configuration', []);

    module.provider('configuration', function () {

        this.data = undefined
        this.configure = configure
        this.$get = $get
        this.isInitalized = isInitalized

        function configure(data) {
            this.data = data
        }

        function isInitalized() {
            return this.data != undefined
        }

        function $get() {
            var configuration = {
                isInitialized: isInitalized,
                data:this.data
            };

            if (this.isInitalized()) {
                angular.extend(configuration, {
                    authority: this.data.authority,
                    etechTasksTabletUri: this.data.etechTasksTabletUri,
                    tasksIntegrated: this.data.tasksIntegrated,
                    integratedInvoicingIntegrated: this.data.integratedInvoicingIntegrated,
                    integratedInvoicingUri: this.data.integratedInvoicingUri
                })
            }
            return configuration
        }
    })
}(angular)
